// Used to store session values on a Session Storage
export const state = () => ({
  // The current Basket Id
  CartId: undefined,

  // The last Order Id placed
  LastOrderId: undefined,

  // True or false if the basket is still enabled
  OrderCompleted: undefined,

  // Funnel Steps trace
  FunnelSteps: undefined,

  // The Updated At timestamp
  updatedAt: undefined,

  // The minisite data
  minisite: {},

  // The Abandoned basket code
  AbandonedBasketUniqueCode: undefined,

  // Voucher Campaigns
  VoucherCamapigns: []
})

export const mutations = {
  CartId: (state, value) => {
    state.CartId = value
    return state
  },
  updatedAt: (state, value) => {
    state.updatedAt = value
    return state
  },
  minisite: (state, payload) => {
    if (payload === undefined) {
      state.minisite = undefined
    } else {
      state.minisite = { ...payload }
    }
    return state
  },
  LastOrderId: (state, value) => {
    state.LastOrderId = value
    return state
  },

  OrderCompleted: (state, value) => {
    state.OrderCompleted = value
    return state
  },

  FunnelSteps: (state, payload) => {
    state.FunnelSteps = { ...payload }
    console.log('MUTATION cart/FunnelSteps payload=', payload)
    return state
  },

  AbandonedBasketUniqueCode: (state, value) => {
    state.AbandonedBasketUniqueCode = value
    return state
  },

  VoucherCamapigns(state, payload) {
    console.log('MUTATION cart/VoucherCamapigns payload=', payload)
    state.VoucherCamapigns = [...payload]
  },

  ToggleVoucherCampaingByTag(state, tag) {
    let newState

    if (tag === undefined) {
      // Reset to false all the selected flag for each Voucher Campaing
      newState = state.VoucherCamapigns.map(c => {
        c.selected = false
        return c
      })
    } else {
      // Update the selected flag for the specific Voucher Campaing via the tag
      newState = state.VoucherCamapigns.map(c => {
        if (c.enabled === true && c.tag === tag) {
          c.selected = true
        } else {
          c.selected = false
        }
        return c
      })
    }
    state.VoucherCamapigns = [...newState]
  }
}

export const getters = {
  CartId: state => {
    return state?.CartId
  },
  updatedAt: state => {
    return state?.updatedAt
  },
  minisite: state => {
    return state?.minisite
  },
  LastOrderId: state => {
    return state?.LastOrderId
  },

  OrderCompleted: state => {
    return state?.OrderCompleted
  },

  FunnelSteps: state => {
    return state?.FunnelSteps
  },

  AbandonedBasketUniqueCode: state => {
    return state?.AbandonedBasketUniqueCode
  },
  // Voucher Campaigns
  VoucherCamapigns(state) {
    return state.VoucherCamapigns?.filter(c => c.enabled === true) || null
  }
}

export const namespaced = true
